import styled from '@emotion/styled';
import { breakpoints } from '~/theme/breakpoints';
import { theme } from '~/theme';
import { StyledCloseIcon } from '~/features/productList/components/FilterBar/SelectedFacets/SelectedFacets.styles';
import ArrowLeft from '~/icons/chevron-left.svg';

export const StyledDeliveryBackIcon = styled(ArrowLeft)({
    width: 15,
    height: 15,
    cursor: 'pointer',
    padding: 0,
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
});

export const StyledStepTwo = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.md]: {
        flexDirection: 'row',
    },
}));
export const StyledDesktopCart = styled.div(() => ({
    display: 'none',
    [breakpoints.md]: {
        display: 'block',
        backgroundColor: theme.colors.grey10,
        padding: `${theme.space[5]} ${theme.space[4]}`,
    },
}));
export const StyledMobileCart = styled.div(() => ({
    display: 'block',
    [breakpoints.md]: {
        display: 'none',
    },
}));

export const StyledOptions = styled.div(() => ({
    width: '100%',
}));

export const StyledList = styled.div(() => ({
    flexShrink: 0,
    display: 'flex',
    span: {
        color: theme.colors.black,
    },
    strong: {
        color: theme.colors.black,
    },
}));

export const StyledDeliveryAddressWrapper = styled.div(() => ({
    flexGrow: 1,
    backgroundColor: `${theme.colors.white}`,
    padding: `${theme.space[3]} ${theme.space[4]}`,
    height: '100%',
    outline: 'none',
}));

export const StyledDeliveryAddressList = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: `${theme.colors.white}`,
}));

export const StyledClickAndCollect = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: `${theme.colors.white}`,
    height: '-webkit-fill-available',
    overflowY: 'auto',
}));

export const StyledButtonWrapper = styled.div(() => ({
    borderTop: `1px solid ${theme.colors.grey40}`,
    padding: theme.space[3],
    width: '100%',
    position: 'fixed',
    left: 0,
    background: theme.colors.white,
    bottom: 0,
}));

export const StyledDeliveryAddressSummary = styled.div(() => ({
    marginTop: theme.space[3],
    maxWidth: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
}));

export const StyledTitle = styled.div(() => ({
    fontSize: theme.fontSizes.lg,
    paddingTop: theme.space[3],
    marginBottom: theme.space[3],
    fontWeight: theme.fontWeights.medium,
    textTransform: 'uppercase',
}));

export const StyledSubTitle = styled.div(() => ({
    fontSize: theme.fontSizes.sm,

    marginBottom: theme.space[3],
}));

export const StyledDeliveryCloseWrapper = styled.div(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
}));

export const StyledDeliveryCloseIcon = styled(StyledCloseIcon)(() => ({
    width: 15,
    height: 15,
    marginLeft: theme.space['2'],
    marginTop: 2,
    cursor: 'pointer',
    padding: 0,
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));
